const Ext = require('ext')
const ClauseTreeMember = require('smartrules/designer/ClauseTreeMember')

// Atomic type of component that can be part of a clause tree, or a group in a clause tree, with a
// meaningful contribution to the generated SmartRules source for a rule.
const Clause = Ext.define(null, { extend: ClauseTreeMember })

module.exports = Clause
